import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Chúng tôi sử dụng cookie',
    description:
      'Chúng tôi sử dụng cookie và các công nghệ tương tự để cung cấp trải nghiệm này. Cookie thực sự cần thiết luôn được bật.',
    allow_label: 'Chấp nhận tất cả cookie',
    reject_label: 'Chỉ cookie thực sự cần thiết',
    settings_label: 'Cài đặt cookie',
    policy_link_label: 'Chính sách quyền riêng tư và cookie',
    categories_label: 'Danh mục',
    always_on_label: 'Luôn bật',
    required_label: 'Bắt buộc',
    save_preferences_label: 'Lưu tùy chọn',
    close_label: 'Đóng',
    allow_all_optional_categories_label: 'Cho phép tất cả danh mục tùy chọn',
    settings_title: 'Cài đặt cookie',
    settings_description:
      'Chúng tôi sử dụng cookie và các công nghệ tương tự để cung cấp trải nghiệm này. Cookie thực sự cần thiết luôn được bật.',
    save_error: 'Không thể lưu lựa chọn quyền riêng tư của bạn. Vui lòng thử lại.'
  },
  categories: {
    strictly_necessary: {
      name: 'Cực kỳ cần thiết',
      purpose: 'Cần thiết để cung cấp trải nghiệm này và không thể tắt.'
    },
    analytics: {
      name: 'Phân tích',
      purpose: 'Đo lường cách khách truy cập sử dụng trải nghiệm này để cải thiện hiệu suất.'
    },
    marketing: { name: 'Tiếp thị', purpose: 'Hỗ trợ quảng cáo và tiếp thị do người tổ chức lựa chọn.' }
  }
};

export default locale;
